export default "__VITE_ASSET__DfOtbiD8__"